export default __webpack_public_path__ + "static/media/ambulance.692c3e73.jpg";